<template>
  <dv-full-screen-container>
    <!--头部开始-->
    <el-row style="height: 10%">
      <el-col :xl="24" :lg="24" :md="24" :sm="24" :sx="24" style="height: 100%">
        <div class="header1 header">
          <div class=" header_time">
            <span class="year">{{ date }}</span>
            <span class="hour" style="margin-left: 10px">{{ time }}</span>
          </div>
          <div class="header_left_nav">
            <router-link to="/">
              <button class="butt ">首页</button>
            </router-link>
          </div>
          <div class="header_left_nav nav1" style="z-index: 100000000">
            <router-link to="/Arrondi" >
              <button class="butt zq">专区</button>
            </router-link>
          </div>
          <div class=" header_title">
            <div class="header_img">
              <img src="../public/images/tixing.png" alt="">
              <div class="header_title_msg" style="left: 43%">
                专馆
              </div>
            </div>
          </div>
          <div class=" nav2 " style="z-index: 100000000">
            <router-link to="/Special" >
              <button class="butt ">专馆</button>
            </router-link>
          </div>
          <div class=" nav3">
            <router-link to="/SpecialCoun" >
              <button class="butt ">专柜</button>
            </router-link>
          </div>
          <div class=" nav5">
            <router-link to="/Information" >
              <button class="butt" >数据</button>
            </router-link>
          </div>
          <div class=" nav4">
            <button class="butt" v-on:click="login_out">退出</button>
          </div>
          <div class="clear-both"></div>
        </div>
      </el-col>
    </el-row>
    <!--头部完毕-->
    <el-row style="height: 45%">
      <el-col :span="8" style="height: 100%">
        <dv-border-box-12>
          <div class="title_msg">专馆消费排行</div>
          <div style="height: 87%">
            <ZList1 msg="实时" style="padding: 0 3%; width: 94%; height: 100%"/>
          </div>
        </dv-border-box-12>
      </el-col>

      <el-col :span="8" style="height: 100%">
        <div class="title_msg">专馆位置分布图</div>
        <div style="height: 90%">
          <Map2 msg="实时" style="padding: 0 3%; width: 94%; height: 100%"/>
        </div>
      </el-col>
      <el-col :span="8" style="height: 100%">
        <el-col :span="24" style="height: 20%">
          <dv-border-box-12>
            <el-card class="box-card " >
              <div class="sales_data_box">
                <div v-for="(v,k,i) in sales_data" :key="i" class="text item sales_data">
                  <p class="sales_data_v">
<!--                    {{v.value}}-->
                    <animate-number from="100" :to="v.value" :key="v.value" duration="1000"></animate-number>
                  </p>
                  <p class="sales_data_n">{{v.name}}<span>  (元)</span> </p>
                </div>
              </div>
              <div class="clear-both"></div>
            </el-card>
          </dv-border-box-12>
        </el-col>
        <el-col :span="24" style="height: 75%; margin-top: 4%">

          <dv-border-box-12>
            <div class="title_msg">专馆位置分布图</div>
            <div style="height: 88%">
            <ZGRanking msg="实时" style="padding: 0 3%; width: 94%; height: 100%"/>
            </div>
          </dv-border-box-12>
        </el-col>
      </el-col>
    </el-row>
    <el-row style="height: 40%;margin-top: 2.5%">
      <el-col :span="8" style="height: 100%;">
        <dv-border-box-12>
          <div class="title_msg">专馆消费帮扶排行</div>
          <div style="height: 65%; margin-top: 12%">
          <ZGRanking1 msg="专馆消费帮扶排行" style="padding: 0 3%; width: 94%; height: 100%"/>
          </div>
        </dv-border-box-12>
      </el-col>
      <el-col :span="16" style="height: 100%;">
        <dv-border-box-12>
          <div class="title_msg">专馆实时消费数据</div>
          <div style="height: 90%; margin-top: 1%">
            <ZGaConsumption msg="专馆消费帮扶排行" style="padding: 0 3%; width: 94%; height: 90%"/>
          </div>
        </dv-border-box-12>
      </el-col>
    </el-row>
  </dv-full-screen-container>
</template>

<script>

import Map2 from '@/views/map/Map2.vue'
import ZList1 from '@/views/zhuanguan/ZList1.vue'
import ZGaConsumption from '@/views/zhuanguan/ZGaConsumption.vue'
import ZGRanking from '@/views/ranking/ZGRanking.vue'
import ZGRanking1 from '@/views/ranking/ZGRanking1.vue'

export default {
  name: "Special",
  data() {
    return {
      sales_data: [
        {
          name:"销售总额",
          value:'',
        },
        {
          name:"帮扶总额",
          value:'',
        },
        {
          name:"专馆个数",
          value:'',
        },
      ],
      time:'',
      date:''
    }
  },
  components: {
    Map2,
    ZList1,
    ZGRanking,
    ZGRanking1,
    ZGaConsumption
  },
  mounted(){

    let user_id = window.localStorage.getItem('user_id');

    // if (!user_id)
    // {
    //   this.$router.push({ path: '/Login' })
    //
    //   return false;
    // }

    const data = {
      'user_id': user_id
    };
    this.$api.zga_summary(data).then(res=>
    {
      console.log(res);
      this.sales_data = res;
    })

    const that = this;
    setInterval(updateTime, 1000);
    function updateTime() {
      const cd = new Date();
      that.time = zeroPadding(cd.getHours(), 2) + ':' + zeroPadding(cd.getMinutes(), 2) + ':' + zeroPadding(cd.getSeconds(), 2);
      that.date = zeroPadding(cd.getFullYear(), 4) + '-' + zeroPadding(cd.getMonth()+1, 2) + '-' + zeroPadding(cd.getDate(), 2);
    };

    function zeroPadding(num, digit) {
      let zero = '';
      for(let i = 0; i < digit; i++) {
        zero += '0';
      }
      return (zero + num).slice(-digit);
    }

  },
  methods: {
    login_out:function(e){
      window.localStorage.clear();
      this.$notify({
        title: '成功',
        message: '退出登录',
        type: 'success'
      });
      this.$router.push({ path: '/Login' })
    }
  }
}
</script>

<style lang="less" scoped>
@import '../public/less/public/list.less';
@import '../public/less/zhuanguan/zhuanguan.less';
</style>